<!--心理评价-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="mentality-page">
            <!--角色卡片-->
            <div class="role-card-row">
                <div class="role-card" v-for="r in roleCards" :key="r.key"
                     :style="{ background: r.bg }" @click="openRole(r)">
                    <div class="role-icon">
                        <el-icon :size="56"><component :is="r.icon" /></el-icon>
                    </div>
                    <div class="role-name">{{ r.title }}</div>
                    <div class="role-desc">{{ r.desc }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import {gainMentalityUrl} from "@/api/admin/mentality";

export default {
    components: {homeHead},
    name: "homeMentality",
    data() {
        return {
            activePath: "teachToolLink",
            userInfo: JSON.parse(this.$storage.get("userInfo")),
            /*角色卡片*/
            roleCards: [
                { key: 'admin', value: '1', title: '管理员', desc: '心理健康工作统筹管理', icon: 'Setting',
                    bg: 'linear-gradient(160deg, #ffb56b 0%, #0d55a4 100%)' },
                { key: 'teacher', value: '2', title: '心理专岗教师', desc: '心理测评与辅导干预', icon: 'Notebook',
                    bg: 'linear-gradient(160deg, #7ec8ff 0%, #3f9bef 100%)' },
                { key: 'expert', value: '3', title: '心理专家', desc: '专业评估与督导支持', icon: 'Medal',
                    bg: 'linear-gradient(160deg, #a78bfa 0%, #7c5ce0 100%)' },
                { key: 'headmaster', value: '4', title: '班主任', desc: '学生心理状态跟进', icon: 'UserFilled',
                    bg: 'linear-gradient(160deg, #6fd9a8 0%, #2fb57d 100%)' },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        openRole(r){
            gainMentalityUrl({username: this.userInfo.username, mentalityRole: r.value}).then(res => {
                if (res.data.code === 1){
                    window.open(res.data.data, '_blank');
                }else {
                    this.$message({message: res.data.msg || '暂未开通，请联系管理员', type: 'info'});
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    overflow-x: hidden;
}

.mentality-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
}

/*角色卡片行：四张卡片均分宽度，整体宽度受视口高度约束，防止纵向溢出*/
.role-card-row {
    display: flex;
    gap: 60px;
    width: 100%;
    max-width: unquote("min(1600px, calc((100vh - 120px) * 2.6))");
    margin: 0 auto;
}

.role-card {
    flex: 1;
    min-width: 0;
    /*卡片高宽比约 4/5，与参考布局的卡片比例接近*/
    aspect-ratio: 4 / 5;
    border-radius: 24px;
    box-shadow: 0 8px 24px rgba(255, 127, 46, .15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform .2s ease;
}

.role-card:hover {
    transform: translateY(-4px);
}

.role-icon {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .25);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.role-name {
    margin-top: 24px;
    font-size: 1.6vw;
    font-weight: 700;
    color: #fff;
    letter-spacing: 2px;
    white-space: nowrap;
    font-family: JiangCheng-700, sans-serif;
}

.role-desc {
    margin-top: 12px;
    font-size: 15px;
    color: rgba(255, 255, 255, .85);
    white-space: nowrap;
}
</style>
